export default function SkiRentalSection() {
  const rentalItems = [
    { icon: 'ri-riding-line', name: 'レンタルスキー・ボード', price: '3,000円〜' },
    { icon: 'ri-t-shirt-line', name: 'ウェア', price: '2,000円〜' },
    { icon: 'ri-hand-heart-line', name: 'グローブ・ゴーグル・帽子', price: '各300円（3点セット500円）' },
  ];

  const benefits = [
    '駐車場無料（朝8時より駐車可能）',
    'チェックイン前のお荷物のお預かりOK',
    'レンタル用品割引：スキー用品・ウェアは1日500円引き、2日で1000円引き',
    'グローブ・ゴーグル・帽子は各300円が3点セットで500円に',
    '冬季宿泊のお客様にはリフト券の割引券あり（大人の方の特典）',
  ];

  return (
    <section className="py-20 md:py-32 px-6 bg-forest-800 relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/4f377db4da1456513652a09ef93df7ba.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></div>

      {/* Washi Texture */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' /%3E%3C/filter%3E%3Crect width='100' height='100' filter='url(%23noise)' opacity='0.4'/%3E%3C/svg%3E")`,
        }}
      ></div>

      <div className="max-w-6xl mx-auto relative">
        {/* Title */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-3">
            スキーレンタル情報
          </h2>
          <p className="text-gold-400 text-lg">Ski Rental Information</p>
          <div className="w-24 h-1 bg-gold-600 mx-auto mt-6"></div>
        </div>

        {/* Rental Items */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 md:p-12 mb-8">
          <div className="grid md:grid-cols-3 gap-8">
            {rentalItems.map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-gold-600 rounded-full mx-auto mb-4">
                  <i className={`${item.icon} text-white text-3xl`}></i>
                </div>
                <h3 className="font-semibold text-white mb-2 text-base">{item.name}</h3>
                <p className="text-gold-400 text-lg font-bold">{item.price}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 pt-8 border-t border-white/20">
            <p className="text-white/80 text-sm text-center leading-relaxed">
              ※ レンタルをご希望の場合は必要な人数・ウェアのサイズ・ブーツのサイズ、身長を教えてください。
              <br />
              ※ スキー場・スキーレンタルをご利用されるお客様は当館のメールにレンタルの内容をご返信ください。
            </p>
          </div>
        </div>

        {/* Winter Benefits */}
        <div className="bg-gold-600 rounded-2xl p-8 md:p-12">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-forest-900 mb-6 text-center">
            あさぎり荘の冬特典
          </h3>

          <div className="grid md:grid-cols-2 gap-4">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-forest-900 text-xl"></i>
                </div>
                <p className="text-forest-900 text-sm leading-relaxed">{benefit}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 pt-8 border-t border-forest-900/20">
            <p className="text-forest-900 text-sm text-center font-medium">
              ※ リフト券を購入される前に当館までお越しください。リフト券購入後の割引は致しかねますのでご了承ください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}